import { formatTime } from 'util/formatTime';

export const formatEventDateLabel = (date: string): string => {
  const d = new Date(date.includes('T') ? date : `${date}T12:00:00`);
  if (Number.isNaN(d.getTime())) return date;

  return d.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatEventTimeRange = (
  startTime?: string,
  endTime?: string,
): string => {
  if (!startTime) return '';
  const start = formatTime(startTime);
  if (!endTime) return start;
  return `${start} - ${formatTime(endTime)}`;
};

export const formatOpensAtLabel = (iso?: string): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';

  const time = d.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  if (d.toDateString() === new Date().toDateString()) return time;

  const date = d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
  return `${date}, ${time}`;
};

export const formatCheckInTimestamp = (iso?: string): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';

  const datePart = d.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  const timePart = d.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return `${datePart} · ${timePart}`;
};

export const formatCheckedInTimeOnly = (iso?: string): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};
